// redux/selectors/tenantPlanSelectors.js
// Base selector
export const getTenantPlanState = (state) => state.tenantPlan;

// Data selectors
export const getTenantPlanData = (state) => {
  const planState = getTenantPlanState(state);
  return planState?.data || null;
};

export const getTenantPlanType = (state) => {
  const data = getTenantPlanData(state);
  return data?.plan || 'BASIC';
};

export const getTenantPlanLoading = (state) => {
  return getTenantPlanState(state)?.loading || false;
};

export const getTenantPlanError = (state) => {
  return getTenantPlanState(state)?.error || null;
};

export const getTenantPlanLastFetched = (state) => {
  return getTenantPlanState(state)?.lastFetched || null;
};

export const getTenantPlanShouldRefetch = (state) => {
  return getTenantPlanState(state)?.shouldRefetch || false;
};

// Derived selectors for specific plan features
export const getIsBasicPlan = (state) => {
  return getTenantPlanType(state) === 'BASIC';
};

export const getIsProPlan = (state) => {
  return getTenantPlanType(state) === 'PRO';
};

export const getIsEnterprisePlan = (state) => {
  return getTenantPlanType(state) === 'ENTERPRISE';
};

export const getPlanFeatures = (state) => {
  const plan = getTenantPlanType(state);
  const isBasic = plan === 'BASIC';
  const isPro = plan === 'PRO';
  const isEnterprise = plan === 'ENTERPRISE';
  
  return {
    plan,
    isBasic,
    isPro,
    isEnterprise,
    maxApps: isBasic ? 5 : isPro ? 20 : 100,
    maxUsers: isBasic ? 10 : isPro ? 100 : 1000,
    hasAnalytics: !isBasic,
    hasSupport24x7: isEnterprise,
    canCustomize: isEnterprise
  };
};